import { render, staticRenderFns } from "./ApproveReconTransactions.vue?vue&type=template&id=72072f58&scoped=true"
import script from "./ApproveReconTransactions.vue?vue&type=script&lang=js"
export * from "./ApproveReconTransactions.vue?vue&type=script&lang=js"
import style0 from "./ApproveReconTransactions.vue?vue&type=style&index=0&id=72072f58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72072f58",
  null
  
)

export default component.exports